import { Grid, Typography } from '@material-ui/core';
import { indigo } from '@material-ui/core/colors';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import AppToolBar from '~/components/AppToolBar';
import GoogleMap from '~/components/GoogleMap.jsx';
import Qrcode from '../assets/qrcode_chowbus.jpg';
import Page from '../components/Page.jsx';

const geoLocation = {
  lat: 41.8780086,
  lng: -87.6260109,
};

const Contact = (props) => {
  const { classes } = props;

  const toMapItem = () => {
    return {
      id: 'location',
      position: geoLocation,
      zIndex: 9999,
      icon: {
        scale: 0.7,
        fillColor: indigo[500],
        strokeColor: 'white',
        fillOpacity: 1,
        path:
          'M0-48c-9.8 0-17.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z',
      },
    };
  };

  return (
    <Page name='contact'>
      <AppToolBar />
      <Grid container justify='center'>
        <Typography variant='h5' style={{ marginTop: 20, marginBottom: 40 }} paragraph>
          Contact Us
        </Typography>
      </Grid>

      <Grid container justify='center'>
        <Grid item xs={10} sm={7}>
          <Grid container alignItems='center'>
            <Grid item xs={12} sm={6} className={classes.map}>
              <GoogleMap id='chowbus-contact' center={geoLocation} items={[toMapItem()]} />
            </Grid>

            <Grid item xs={12} sm={5}>
              <Grid container direction='column'>
                <Typography paragraph variant='subtitle2'>
                  E: hello@chowbus.com
                </Typography>

                <Typography variant='subtitle2'>224 S Michigan Ave, Suite 400</Typography>

                <Typography variant='subtitle2'>Chicago, IL, 60604</Typography>

                <Typography variant='subtitle2'>USA</Typography>

                <div className={classes.qrcode}>
                  <img style={{ width: '100%' }} src={Qrcode} />
                </div>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Page>
  );
};

const style = (theme) => ({
  map: {
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
      height: 300,
      marginBottom: 20,
    },
    marginRight: 40,
    height: 400,
  },
  qrcode: {
    [theme.breakpoints.down('md')]: {
      width: '60%',
      margin: 'auto',
    },
    width: 250,
  },
});

export default withStyles(style)(Contact);

export async function getStaticProps() {
  return {
    props: {},
  };
}
